/** 引入Vue库 */
import Vue from 'vue'

/** 引入Vue-router路由库 */
import Router from 'vue-router'

/** 解决重复点击同一个路由造成的报错 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

/** 引入提示弹窗 */
// import { MessageTime } from '../utils/Tool'

/** 引入Api自动登录 */
import Api from '../api/index'

/** Router路由进行实例化 */
Vue.use(Router)


// import common from './modules/common';
import Error from '@/components/Error/index' //404
import index from '@/pages/index/index';
import subpage from '@/pages/subpage/index';
import detail from '@/pages/detail/index';
import info from '@/pages/info/index';
import demo from '@/pages/index/demo';
import login from '@/pages/login/index';
import technology from '@/pages/technology/index';
import adminIndex from '@/pages/admin/index';
import adminXl from '@/pages/admin/xl';
import adminWl from '@/pages/admin/wl';
import adminDevice from '@/pages/admin/device';
import h5 from '@/pages/h5/index';

/** 配置路由文件 */

const router = new Router({
	mode: 'hash',
	routes: [
      {path: '', redirect: '/index' },
      {path: '/index', name:'index', component: index, meta: {requireLogin : false, layout: 'main-layout'}},
      {path: '/subpage', name:'subpage', component: subpage, meta: {requireLogin : false, layout: 'main-layout'}},
      {path: '/detail', name:'detail', component: detail, meta: {requireLogin : false, layout: 'main-layout'}},
      {path: '/info', name:'info', component: info, meta: {requireLogin : false, layout: 'main-layout'}},
      {path: '/demo', name:'demo', component: demo, meta: {requireLogin : false, layout: 'main-layout'}},
      {path: '/technology', name:'technology', component: technology, meta: {requireLogin : false, layout: 'main-layout'}},
      {path: '/login', name:'login', component: login, meta: {requireLogin : false, layout: 'blank-layout'}},
      {path: '/admin', redirect: '/admin/index' },
      {path: '/admin/index', name:'adminIndex', component: adminIndex, meta: {requireLogin : true, layout: 'main-layout2'}},
      {path: '/admin/xl', name:'adminXl', component: adminXl, meta: {requireLogin : true, layout: 'main-layout2'}},
      {path: '/admin/wl', name:'adminWl', component: adminWl, meta: {requireLogin : true, layout: 'main-layout2'}},
      {path: '/admin/device', name:'adminDevice', component: adminDevice, meta: {requireLogin : true, layout: 'main-layout2'}},
      {path: '/h5', name:'h5', component: h5, meta: {requireLogin : false, layout: 'blank-layout'}},
      {
          path: '*',
          name: 'Error',
          component: Error,
          meta :{ layout: 'blank-layout', noNeedLogin : true}
      },
    ]
})
router.beforeEach(async (to, from, next) => {   
    let isLogin = JSON.parse(sessionStorage.getItem('username_2'));
    if(to.meta.requireLogin){
        if(isLogin){
            next()
        }else{
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        }
    }else{
        next()
    }
})

export default router
